import { StakingScreen } from '@app/screens/Staking/StakingScreen';
import { StakingEnrollmentsScreen } from '@app/screens/StakingEnrollments/StakingEnrollmentsScreen';
import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';

import { StakingParamsRecord } from './';
import { useMainDrawerNavigation } from '../MainDrawerNavigation';

export type StakingEnrollmentDetailsScreenParams = {
	id: number;
};

const Stack = createStackNavigator<StakingParamsRecord>();

export function useStakingNavigation() {
	const navigation = useMainDrawerNavigation('Staking');

	return {
		Staking: () =>
			navigation.Base({
				screen: 'Staking',
			}),
		Enrollments: () =>
			navigation.Base({
				screen: 'Enrollments',
			}),
	};
}

export function StakingNavigation() {
	return (
		<Stack.Navigator>
			<Stack.Screen component={StakingScreen} name="Overview" />
			<Stack.Screen component={StakingEnrollmentsScreen} name="Enrollments" />
		</Stack.Navigator>
	);
}
